import React from 'react';
import { Message, MessageProps } from '../Message/Message';

/**
 *
 * Component for remote message
 * @usage <RemoteMessage
 * text = 'lorem ipsum'
 * icon = 'path to logo'
 * />
 */
const RemoteMessage = ({ ...props }: MessageProps): JSX.Element => {
  return <Message messageType="remote" {...props} />;
};

export { RemoteMessage };
